import AreaTypesServiceAPI from "../api/areaTypeApi";

/**
 * Set Layer on Dockyard Areas by AreaType
 * @param dockyardAreas
 * @param displayNoGeom
 * @returns {Promise<[]|null>}
 */
export const loadFeaturesByAreaTypes = async (dockyardAreas, displayNoGeom = false) => {
    let dataAreaTypes = await AreaTypesServiceAPI.getAreaTypes('', {});
    let mapLayers = []
    for (let areaType of dataAreaTypes.data) {
        let features = []
        dockyardAreas
            .filter(dockyardArea => {
                    return dockyardArea.area_type_id === areaType.json_data.id
                }
            )
            .map(dockyardArea => {
                    let featureGeoJson
                    if (dockyardArea.geom) {
                        featureGeoJson =
                            {
                                'type': 'Feature',
                                'geometry': dockyardArea.geom,
                                'properties':
                                    {
                                        area_type: dockyardArea.area_type,
                                        descr: dockyardArea.descr,
                                    } || {}
                            }
                    }
                    featureGeoJson && features.push(featureGeoJson)
                    return true
                }
            )
        let layerId = `layer_${areaType.json_data.id}`
        let layerColor = areaType.json_data.color || null;
        // Test to display all layers, or only layer features if no display layer w/ empty geom
        (
            displayNoGeom ||
            (!displayNoGeom && features.length !== 0)
        )
        && mapLayers.push(
            {
                id: layerId,
                source: getFeatureData(features),
                layer: getFeatureLayer(layerId, layerColor,
                    {
                        label: areaType.json_data.name || null,
                        lockvisibility: (areaType.json_data.level && parseInt(areaType.json_data.level) < 0) || false
                    })
            }
        )
    }

    return mapLayers || null;
}

/**
 * Generate Feature Collection to set on layer
 * @param features
 * @returns {{data: {features: *, type: string}, type: string}}
 */
const getFeatureData = (features) => {
    return {
        'type': 'geojson',
        'data': {
            'type': 'FeatureCollection',
            'features': features
        }
    };
}

/**
 * Set Layer Type to set on Layer
 * @param layerId
 * @param color
 * @param layerMetadata
 * @returns {{layout: {}, paint: {"fill-color": (*|string), "fill-opacity": number}, id: *, source: *, type: string}}
 */
const getFeatureLayer = (layerId, color, layerMetadata = {}) => {
    return {
        'id': layerId,
        'type': 'fill',
        'source': layerId,
        'layout': {
            'visibility': 'visible'
        },
        'metadata': {
            'layername': (layerMetadata && layerMetadata.label) || 'Non renseigné',
            'lockvisibility': (layerMetadata.lockvisibility) || false,
            'layertype': 'Types de zone',
        },
        'paint': {
            'fill-color': color || '#088',
            'fill-opacity': 0.5
        }
    };
}